/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "sharing-c068b7a4--sprite",
  "use": "sharing-c068b7a4--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sharing-c068b7a4--sprite\"><path d=\"M9 10.25l3-1.75 3-1.75m-6 7l3 1.75 3 1.75\" stroke=\"#fff\" stroke-width=\"2\" /><circle cx=\"6\" cy=\"12\" r=\"3\" stroke=\"#fff\" stroke-width=\"2\" /><circle cx=\"18\" cy=\"5\" r=\"3\" stroke=\"#fff\" stroke-width=\"2\" /><circle cx=\"18\" cy=\"19\" r=\"3\" stroke=\"#fff\" stroke-width=\"2\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
